$(document).foundation();

// ScrollReveal
window.sr = ScrollReveal({ reset: true, mobile: false, easing: 'ease-in-out', duration: 500, scale: 0.9, });
sr.reveal('section p');
sr.reveal('.bottom-logo', { distance: '0px', scale: 0.25});
sr.reveal('.links', { origin: 'right', distance: '100px', scale: 1 });
sr.reveal('.fab');


$(document).ready(function() {
	console.log(":)))");
	$('#we-are-open').foundation('open');

	$('main').parallax({
		imageSrc: '/images/body-bg.jpg'
	});
	
	$('.full-slider').slick({
	  infinite: true,
	  autoplay: true,
	  autoplaySpeed: 3000,
	  pauseOnHover: false

	});	
	
	
	$(document).languageDetection({
		domain      :  window.location.protocol + '//'+ window.location.host +'/',
		languages   :   [
			{
				code : 'en',
				path : 'en',
			},
			{
				code : 'es',
				path : '',
				defaultLanguage : true
			}
		],
		expires       :  10		
	});
});
